import * as React from "react";
import type { SVGProps } from "react";
const SvgKamera = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 91 115.031" {...props}>
    <path
      d="m488.553 313.455-14.234 5.945v-6.247a4.35 4.35 0 0 0-4.328-4.381h-2.362a19.37 19.37 0 1 0-28.668 0h-11.815a14.73 14.73 0 0 0 2.5-8.247 14.488 14.488 0 1 0-28.975 0 14.76 14.76 0 0 0 2.506 8.259 4.34 4.34 0 0 0-4.165 4.369v25.707a4.35 4.35 0 0 0 4.328 4.382h9.594v3.46a4.35 4.35 0 0 0 4.33 4.383h5.255L408.88 387.45a2.636 2.636 0 0 0 1.5 3.384 2.5 2.5 0 0 0 .925.173 2.6 2.6 0 0 0 2.425-1.69l14.355-38.241h5.984v25.028a2.6 2.6 0 1 0 5.2 0V351.08h5.589l14.341 38.241a2.61 2.61 0 0 0 2.428 1.686 2.5 2.5 0 0 0 .925-.169 2.646 2.646 0 0 0 1.5-3.388l-13.637-36.37h.6a4.35 4.35 0 0 0 4.33-4.381v-3.457H470a4.35 4.35 0 0 0 4.328-4.38v-6.252l14.234 5.949a.867.867 0 0 0 1.423-.832v-23.435a.878.878 0 0 0-1.432-.837"
      style={{
        fill: "currentColor",
        fillRule: "evenodd",
      }}
      transform="translate(-399 -275.969)"
    />
  </svg>
);
export default SvgKamera;
